/* ============================================================
   Cloudflare Turnstile for the custom contact forms (Need Help pop-up,
   contact page, Service Discount). The contact Worker
   (backend/contact-worker/) verifies the token each form sends as
   "cf-turnstile-response".

   - Each form holds a <div class="cf-turnstile" data-sitekey=…>; Turnstile
     renders into it and adds the hidden token input inside the form, so
     FormData picks it up with no extra wiring.
   - The Turnstile script loads on the first interaction with any of these
     forms instead of on every page view.
   - Appearance is "interaction-only": invisible for nearly everyone; a
     checkbox shows only when Cloudflare wants a check from a risky visitor.

   API used by the form scripts:
     ATVTurnstile.load()            load the script (idempotent)
     ATVTurnstile.waitForToken(form) promise; resolves once the form has a
                                     token, or after a timeout (the Worker
                                     still accepts the post, but flags it)
     ATVTurnstile.reset(form)       fresh token after a submit (tokens are
                                     single-use)
     ATVTurnstile.strip(obj)        removes the token key from an object
                                     (keeps it out of Klaviyo properties)
   ============================================================ */
(function () {
  if (window.ATVTurnstile) return;

  var SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
  var TOKEN_NAME = 'cf-turnstile-response';
  var loading = null;

  function load() {
    if (loading) return loading;
    loading = new Promise(function (resolve) {
      if (window.turnstile) return resolve();
      var s = document.createElement('script');
      s.src = SCRIPT_SRC;
      s.async = true;
      s.defer = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { resolve(); }; // never block a submission on this
      document.head.appendChild(s);
    });
    return loading;
  }

  function tokenOf(form) {
    var input = form.querySelector('input[name="' + TOKEN_NAME + '"]');
    return input ? input.value : '';
  }

  function waitForToken(form, timeoutMs) {
    var limit = timeoutMs || 8000;
    if (!form.querySelector('.cf-turnstile')) return Promise.resolve('');
    return load().then(function () {
      return new Promise(function (resolve) {
        var started = Date.now();
        (function check() {
          var t = tokenOf(form);
          if (t || Date.now() - started > limit) return resolve(t);
          setTimeout(check, 150);
        })();
      });
    });
  }

  function reset(form) {
    if (!window.turnstile) return;
    var el = form.querySelector('.cf-turnstile');
    if (!el) return;
    try { window.turnstile.reset(el); } catch (_) {}
  }

  function strip(obj) {
    if (obj) delete obj[TOKEN_NAME];
    return obj;
  }

  // Load on first interaction with any protected form.
  function onFirstInteraction(e) {
    var form = e.target && e.target.closest && e.target.closest('form');
    if (!form || !form.querySelector('.cf-turnstile')) return;
    document.removeEventListener('focusin', onFirstInteraction, true);
    document.removeEventListener('pointerdown', onFirstInteraction, true);
    load();
  }
  document.addEventListener('focusin', onFirstInteraction, true);
  document.addEventListener('pointerdown', onFirstInteraction, true);

  window.ATVTurnstile = { load: load, waitForToken: waitForToken, reset: reset, strip: strip };
})();
